export default "__VITE_ASSET__DOWa3N4v__"